// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IconForCardZ_wrapper__1STAB"};